export type HeaderState = "none" | "some" | "all";

export const toggleRoom = (selected: string[], id: string): string[] =>
  selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id];

export const getHeaderState = (
  selected: string[],
  visibleIds: string[],
): HeaderState => {
  if (visibleIds.length === 0) return "none";
  const count = visibleIds.filter((id) => selected.includes(id)).length;
  if (count === 0) return "none";
  return count === visibleIds.length ? "all" : "some";
};

export const toggleAll = (
  selected: string[],
  visibleIds: string[],
): string[] => {
  if (visibleIds.length === 0) return selected;
  if (getHeaderState(selected, visibleIds) === "all") {
    return selected.filter((id) => !visibleIds.includes(id));
  }
  return [...selected, ...visibleIds.filter((id) => !selected.includes(id))];
};

/** Drops ids that are no longer visible (page or filter change). Returns the same array when nothing changes. */
export const pruneSelection = (
  selected: string[],
  visibleIds: string[],
): string[] => {
  const kept = selected.filter((id) => visibleIds.includes(id));
  return kept.length === selected.length ? selected : kept;
};
